/**
 * Badge component overrides.
 * Pill-shaped badges with subtle shadow depth.
 */

import type { Theme } from '@mui/material/styles';

const badges: Theme['components'] = {
  MuiBadge: {
    styleOverrides: {
      badge: {
        borderRadius: 999,
        minWidth: 20,
        height: 20,
        padding: '0 6px',
        fontWeight: 600,
        fontSize: '0.6875rem',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
      },
      dot: {
        width: 8,
        height: 8,
        minWidth: 8,
        borderRadius: 999,
        padding: 0,
      },
    },
  },
};

export default badges;
